// src/store/slices/wardsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance"; // ✅ use your existing axios instance

export const fetchWardsThunk = createAsyncThunk(
  "wards/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/wards");
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const createWardThunk = createAsyncThunk(
  "wards/create",
  async ({ ward_name }, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.post("/api/wards", { ward_name });
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      // refresh list
      dispatch(fetchWardsThunk());
      return true;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const updateWardThunk = createAsyncThunk(
  "wards/update",
  async ({ ward_id, ward_name }, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.put(`/api/wards/${ward_id}`, { ward_name });
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      dispatch(fetchWardsThunk());
      return true;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const deleteWardThunk = createAsyncThunk(
  "wards/delete",
  async ({ ward_id }, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.delete(`/api/wards/${ward_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      dispatch(fetchWardsThunk());
      return true;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const wardsSlice = createSlice({
  name: "wards",
  initialState: {
    list: [],
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearWardsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchWardsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWardsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchWardsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load wards";
      })

      // create/update/delete -> saving
      .addMatcher(
        (a) =>
          a.type === createWardThunk.pending.type ||
          a.type === updateWardThunk.pending.type ||
          a.type === deleteWardThunk.pending.type,
        (state) => {
          state.saving = true;
          state.error = null;
        }
      )
      .addMatcher(
        (a) =>
          a.type === createWardThunk.fulfilled.type ||
          a.type === updateWardThunk.fulfilled.type ||
          a.type === deleteWardThunk.fulfilled.type,
        (state) => {
          state.saving = false;
        }
      )
      .addMatcher(
        (a) =>
          a.type === createWardThunk.rejected.type ||
          a.type === updateWardThunk.rejected.type ||
          a.type === deleteWardThunk.rejected.type,
        (state, action) => {
          state.saving = false;
          state.error = action.payload || "Operation failed";
        }
      );
  },
});

export const { clearWardsError } = wardsSlice.actions;
export default wardsSlice.reducer;
